import { useState } from "react";
import { useTranslation } from "react-i18next";
import { inventoryBarcodes } from "@/apis/inventory";
import errorCodes from "@/apis/error";
import { App } from "antd";

type FetchBarcodes = (id: string) => Promise<Array<string>>;
type IUseInventoryBarcodes = () => [ boolean, { getCodes: FetchBarcodes } ]

const useInventoryBarcodes:IUseInventoryBarcodes = () => {
  const { notification } = App.useApp();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false)

  const fetchBarcodes: FetchBarcodes = (id: string) => {
    setLoading(true)
    return new Promise((res) => {
      inventoryBarcodes(id)
        .then((info) => res(info))
        .catch((err) => {
          notification.error({ placement: 'top', message: t('order.fetchBarcodesFailt', {err: errorCodes[err] || err}) });
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return [ loading, { getCodes: fetchBarcodes } ]
}

export default useInventoryBarcodes;